<template>
  <div id="app">
    <AppNav />
    <transition name="page" mode="out-in">
      <router-view :key="$route.path" />
    </transition>
    <ToastNotification />
    <UpdateAnnouncement />
    <MessageCenter />
  </div>
</template>

<script>
import AppNav from '@/components/AppNav.vue'
import ToastNotification from '@/components/ToastNotification.vue'
import UpdateAnnouncement from '@/components/UpdateAnnouncement.vue'
import MessageCenter from '@/components/MessageCenter.vue'

export default {
  name: 'App',
  components: { AppNav, ToastNotification, UpdateAnnouncement, MessageCenter }
}
</script>

<style lang="scss">
@import '@/styles/global.scss';
</style>
